import { useContext } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import { PINK } from 'static/config/worldVariables';
import styled from 'styled-components/macro';

export const MouseDraggingSelection = (): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);

    return (
        <S_MouseDraggingSelection
            style={{
                width: ctxEdit.mouseDraggingSelection?.width,
                height: ctxEdit.mouseDraggingSelection?.height,
                left: ctxEdit.mouseDraggingSelection?.left,
                top: ctxEdit.mouseDraggingSelection?.top
            }}
        />
    );
};

export const S_MouseDraggingSelection = styled.div`
    border: 1px dashed ${PINK};
    display: block;
    position: absolute;
    background: none;
    pointer-events: all;
`;
